export { default as CoreConfigBounce } from './Bounce';
